import { render, staticRenderFns } from "./check-item.vue?vue&type=template&id=bd6f91a2&scoped=true"
import script from "./check-item.vue?vue&type=script&lang=js"
export * from "./check-item.vue?vue&type=script&lang=js"
import style0 from "./check-item.vue?vue&type=style&index=0&id=bd6f91a2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6f91a2",
  null
  
)

export default component.exports